import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
// import VocationLogo from '../imgs/vocation_start_logo.png';

const ClosingPage = ({ background, user, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>{user.name || 'Despedida'}</h3>
          <p className='justified'>
            Con este informe pudiste reflexionar sobre cómo estudias, qué te
            motiva a aprender, qué piensas sobre tus propias habilidades y qué
            recursos tienes para enfrentar el paso a la enseñanza media. Esta
            información te servirá para saber cómo te encuentras frente a la
            nueva etapa escolar que te toca.
          </p>
          <p className='justified'>
            Es completamente normal sentir un poco de miedo o ansiedad cuando se
            acercan cambios importantes. A todos nos pasa. Pero podemos hacer
            distintas cosas para disminuir la preocupación y prepararnos mejor:
            hablar con tus compañeros/as sobre lo que sientes, preguntar a
            estudiantes de cursos superiores por su experiencia, reconocer tus
            logros y capacidades, y, si es necesario, hacer pequeños ajustes en
            tu forma de estudiar para lograr tus metas académicas sin tanto
            estrés.{' '}
            <strong>
              Lo importante es que confíes en ti y en tu capacidad para
              adaptarte, seguir aprendiendo y disfrutar también este nuevo
              camino. Porque lo que viene es una gran etapa, llena de desafíos,
              aprendizajes y experiencias nuevas por descubrir.
            </strong>
          </p>
          <br />
          <p className='text-center'>
            <strong>¡Te deseamos mucho éxito en esta nueva etapa!</strong>
          </p>
          <p className='text-center'>Equipo Edumetrics</p>

          <br />
          <br />
          <br />
          <br />
          <br />

          <div className='text-center'>
            <p>
              También puedes visitar el siguiente QR para revisar tus resultados
              online:
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              marginTop: 16

              // width: '100%'
              // display: 'flex',
              // justifyContent: 'center'
            }}
          >
            <img
              src={`https://www.edumetrics.cl/api/qr?url=https://www.edumetrics.cl/report/${user?.responseId}?k=${user?.responseAccessKey}`}
              alt='qr code'
              style={{
                width: 100,
                height: 100,
                display: 'block'
              }}
            />
          </div>
        </div>
      </BodyContainer>
      {/* <div
        style={{
          position: 'absolute',
          bottom: 50,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          margin: 'auto'
        }}
      >
        <img
          src={VocationLogo}
          alt='edumetrics vocation start logo'
          style={{
            width: 250,
            height: '100%',
            display: 'block'
          }}
        />
      </div> */}
    </SlidePage>
  );
};

export default ClosingPage;
